import React from "react";
import Navbar from "../../components/Navbar/Navbar";
import { useEffect } from "react";
import ScrollToTopButton from "../../components/ScrollToTopButton/ScrollToTopButton";
import DarkModeButton from "../../components/DarkModeButton/DarkModeButton";
import './Copyright.css';

export default function PrivacyPolicy() {

  useEffect(() => {
    document.title = "Kút Online — Szerzői jogi és felhasználási feltételek";
  }, []);

  return (
    <div>
      <Navbar />
      <DarkModeButton/> 

        <div class="page-container p-4">
            <h1 class="copyright">Szerzői jogi és felhasználási feltételek</h1>

        <p><strong>Hatályos: 2025. szeptember 1-től</strong></p>


            <h2>1. A tartalom tulajdonjoga</h2>
            <p>
                Minden, a Kút Online-on megjelenő eredeti tartalom (szöveg, kép, grafika, videó, hang,
                adatbázis, design) szerzői jogi védelem alatt áll, és a Kút Online vagy a tartalom szerzője
                (jogosult) kizárólagos joga alatt áll. A tartalmak bármilyen más módon történő másolása,
                terjesztése, nyilvános közlése, átdolgozása vagy újraközlése csak írásos engedéllyel lehetséges.
            </p>

            <h2>2. Megengedett felhasználás</h2>
            <p>
                Az oldalról saját, nem kereskedelmi célú, személyes használatra történő
                letöltés/megőrzés megengedett, feltéve, hogy a forrást (Kút Online) és a szerzőt egyértelműen
                feltüntetik, és a mű integritása nem sérül.
            </p>
            <p>
                Idézés: A nyilvánosságra hozott mű részletének idézése indokolt terjedelemben, a forrás és
                a szerző feltüntetésével, a hatályos szerzői jogi szabályoknak megfelelően történhet.
            </p>

            <h2>3. Tiltott/korlátozott felhasználások</h2>
            <p>
                Tilos a Kút Online tartalmának engedély nélküli kereskedelmi felhasználása, ideértve a
                cikkek, képek vagy videók eladását, más oldalon való teljes újraközlését vagy a tartalom olyan
                módon történő felhasználását, amely szerzői jogsértést eredményez.
            </p>
            <p>
                Nem megengedett a tartalom technikai eltávolítása,
                illetve a szerző személyhez fűződő jogainak megsértése.
            </p>

            <h2>4. Felhasználói tartalom</h2>
            <p>
                A beküldött tartalommal a felhasználó kijelenti, hogy jogosult a tartalom felhasználására,
                és annak beküldésével a Kút Online részére kizárólagos felhasználási jogot enged, időbeli és
                területi korlátozás nélkül.
            </p>

            <h2>5. Hivatkozás, beágyazás, linkelés</h2>
            <p>
                A Kút Online cikkeire történő hivatkozás (linkelés) megengedett, feltéve, hogy a link nem
                tartalmaz megtévesztő állítást és a link megnyitása nem teszi lehetővé a teljes cikk másolását
                vagy offline elérését a forrásmegjelölés eltávolítása nélkül.
            </p>
            <p>
                Beágyazás: harmadik fél által szolgáltatott beágyazott tartalom (pl. YouTube-video) esetén a
                beágyazás engedélyezett, ha az eredeti szolgáltató beágyazási mechanizmusát használja a
                felhasználó, és az nem törli a forrásmegjelölést.
            </p>

            <h2>8. Szerzői jogi figyelmeztetés</h2>
            <p>
                A Kút Online fenntartja minden jogát. Minden engedély nélküli felhasználás jogi következményeket
                vonhat maga után (kártérítés, bírósági eljárás).
            </p>


                <h2>9. Módosítási záradék</h2>
                <p>
                    A jelen feltételek időről időre módosulhatnak. A módosítások a weboldalon történő közzététel napjától hatályosak.
                </p>

                <h2>10. Joghatóság</h2>
                <p>
                    A feltételekre a magyar jog az irányadó. Vitás ügyekben a Szombathelyi Törvényszék kizárólagos illetékességgel jár el.
                </p>

                <h2>11. Moderáció és eltávolítás</h2>
                <p>
                    A szerkesztőség fenntartja a jogot, hogy a beküldött tartalmat szerkessze, visszautasítsa vagy eltávolítsa, különösen jogsértés, etikátlan tartalom vagy technikai okok miatt.
                </p>

                <h2>12. Jogellenes tartalom bejelentése</h2>
                <p>
                    Jogellenes vagy jogsértő tartalom bejelentése esetén kérjük, írjon a <a href="mailto:kutonlineujsag@gmail.com">kutonlineujsag@gmail.com</a> címre.
                </p>

                <h2>13. Felelősségkorlátozás</h2>
                <p>
                    A Kút Online mindent megtesz a tartalom pontosságáért, de nem vállal felelősséget az esetleges hibákért, elírásokért vagy az oldal használatából eredő károkért.
                </p>

                <h2>14. Védjegyek és logók</h2>
                <p>
                    A weboldalon szereplő védjegyek, logók és arculati elemek a jogosultak tulajdonát képezik, azok engedély nélküli felhasználása tilos.
                </p>

                <h2>15. Technikai tiltások</h2>
                <p>
                    Tilos a weboldal tartalmának automatizált letöltése (scraping), watermark vagy metaadat eltávolítása, illetve bármilyen technikai védelmi intézkedés megkerülése.
                </p>
        </div>
      <ScrollToTopButton />
    </div>
  );
}
